import * as React from 'react';
import { Classes } from '../index';
import { Icon } from '../icon/Icon';
import classNames from 'classnames';
import { mcNavigateNext } from '@mc/react-ui-icons';

export type BreadcrumbsProps = React.PropsWithChildren<{ className?: string }>;
/**
 * Breadcrumbs - komponenta pro navigaci mezi stránkama.
 * */
export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  children,
  className,
}) => {
  const childrenArray = React.Children.toArray(children);

  return (
    <div className={classNames(Classes.BREADCRUMBS, className)}>
      {childrenArray.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < childrenArray.length - 1 && (
            <Icon
              icon={mcNavigateNext}
              intent={'secondary'}
              className={Classes.BREADCRUMB_ICON}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
